import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import Select from 'react-select';
import axios from 'axios';
import { APIURL, TZ } from '../../../Global';
import sampleList from './sampleList';
import { useAlert } from 'react-alert';
import CustomSelect from '../AddMedicines/CustomSelect';
import { optionsList } from '../AddMedicines/formOptions';
const TestShow = (props) => {
    const [testData, setTestData] = useState({
        sample: props.sample,
        name: '',
        unit: '',
        note: '',
    });
    const [refRange, setRefRange] = useState([
        {
            category: '',
            min_value: '',
            max_value: '',
        },
    ]);
    const [panels, setPanels] = useState([]);
    const [panelsList, setPanelsList] = useState([]);
    const [error, setError] = useState({
        sample: '',
        panels: '',
    });
    const alert = useAlert();

    const samples = sampleList.map((item) => ({ value: item, label: item }));

    useEffect(() => {
        if (testData.sample !== '') {
            const tokenString = sessionStorage.getItem('usertoken');
            const str = tokenString.replace(/["]+/g, '');
            axios
                .get(`${APIURL}/api/v1/staff/lab-test/?sample=${testData.sample}&${TZ}`, {
                    headers: {
                        Authorization: 'Token ' + str,
                    },
                })
                .then((res) => {
                    if (res.status === 200 && res.data.status === 'success') {
                        const panelsOptions = res.data.panels.map((panel) => ({
                            value: panel.id,
                            label: panel.panel_name,
                        }));
                        setPanelsList(panelsOptions);
                    } else {
                        alert.error(res.data.message || 'Error fetching tests.');
                    }
                })
                .catch((err) => {
                    alert.error('Error fetching sample data.');
                });
        }
    }, [testData.sample]);

    const handleSampleChange = (selectedOption) => {
        setError((currentState) => ({
            ...currentState,
            sample: '',
        }));

        if (!selectedOption) {
            setTestData((current) => ({ ...current, sample: '' }));
            setPanelsList([]);
            return;
        }

        setTestData((current) => ({
            ...current,
            sample: selectedOption.value,
        }));

        setPanels([]);
    };

    const handleCategoryClick = (category) => {
        setTestData((current) => ({
            ...current,
            sample: category,
        }));
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setTestData((current) => ({
            ...current,
            [name]: value,
        }));
        setError((currentState) => ({
            ...currentState,
            testName: '',
        }));
    };

    const handleRefRangeChange = (index, e) => {
        const { name, value } = e.target;
        const updatedRefRange = [...refRange];
        updatedRefRange[index][name] = value;
        setRefRange(updatedRefRange);
    };

    const handleRefChange = (index, selectedOption) => {
        const updatedRefRange = [...refRange];
        updatedRefRange[index].category = selectedOption.value;
        setRefRange(updatedRefRange);
    };


    const addRefRange = () => {
        setRefRange([
            ...refRange,
            {
                category: '',
                min_value: '',
                max_value: '',
            },
        ]);
    };

    const removeRefRange = (index) => {
        const updatedRefRange = refRange.filter((_, i) => i !== index);
        setRefRange(updatedRefRange);
    };

    const handleTestChange = (selectedOptions) => {
        setError((currentState) => ({
            ...currentState,
            tests: '',
        }));

        if (!selectedOptions) {
            setPanels([]);
            return;
        }

        setPanels(selectedOptions);
    };

    const handleSubmit = () => {
        if (!testData.sample || testData.name === "") {
            if (!testData.sample) {
                setError((currentState) => ({ ...currentState, sample: 'Sample is required.' }));
            }
            if (!testData.name || testData.name === "") {
                setError((currentState) => ({ ...currentState, testName: 'Test Name is required.' }));
            }
            return;
        }

        const invalidRanges = refRange.some(range => {
            const hasSomeFields = range.category || range.min_value || range.max_value;
            const hasAllFields = range.category && range.min_value && range.max_value;

            return hasSomeFields && !hasAllFields;
        });

        if (invalidRanges) {
            alert.error('Please complete all fields for each reference range (category, min, and max values)');
            return;
        }

        const payload = {
            test_name: testData.name,
            sample: testData.sample,
            panel_ids: panels.map((test) => test.value),
            unit: testData.unit,
            note: testData.note,
            reference_parameter: refRange.filter(
                (range) => range.category && range.min_value && range.max_value
            ),
        };

        const tokenString = sessionStorage.getItem('usertoken');
        const str = tokenString.replace(/["]+/g, '');
        axios
            .post(`${APIURL}/api/v1/staff/lab-test/?${TZ}`, payload, {
                headers: {
                    Authorization: 'Token ' + str,
                },
            })
            .then((res) => {
                if (res.status === 200 && res.data.status === 'success') {
                    alert.success('Test added successfully!');
                    props.handleSuccess();
                } else {
                    alert.error(res.data.message || 'Failed to add test.');
                }
            })
            .catch((err) => {
                alert.error('Failed to add test. Please try again.');
            });
    };

    return (
        <div>
            <Modal
                {...props}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                backdrop="static"
                keyboard={false}
                show={true}
            >
                <Modal.Header closeButton onHide={props.onClose}>
                    <Modal.Title><b>Add Test</b></Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ display: "flex" }}>
                    <div className="left-side-buttons col-3" style={{ padding: 0 }}>
                        <div className="left-side-buttons-title">Samples</div>
                        <div className="left-side-buttons" style={{ borderRadius: 0, border: "none" }}>
                            {sampleList.map((category) => (
                                <button
                                    key={category}
                                    className={`category-button ${testData.sample === category ? "active" : ""}`}
                                    onClick={() => handleCategoryClick(category)}
                                >
                                    {category}
                                </button>
                            ))}
                        </div>
                    </div>
                    <div className="panel-container col-9">
                        <div className='pricing-inputcontainer'>
                            <span>Required sample</span>
                            <input
                                style={{ textTransform: "capitalize" }}
                                value={testData.sample}
                                disabled
                            />
                        </div>
                        <div className='pricing-inputcontainer'>
                            <span className='required'>Test Name</span>
                            <input
                                className={`${error.testName ? 'has-error-input' : ''}`}
                                name="name"
                                placeholder='Test Name'
                                value={testData.name}
                                onChange={handleInputChange}
                            />
                            {error.testName && <div className="error-message">{error.testName}</div>}
                        </div>
                        <div className='pricing-inputcontainer'>
                            <span>Unit</span>
                            <input
                                name="unit"
                                placeholder='Unit'
                                value={testData.unit}
                                onChange={handleInputChange}
                            />
                        </div>
                        <div className='pricing-inputcontainer'>
                            <span>Reference Range</span>
                            {refRange.map((range, index) => (
                                <div key={index} style={{ display: 'flex', gap: '10px', marginBottom: '10px' }}>
                                    <div className='col-5' style={{ padding: 0 }}>
                                        <CustomSelect
                                            options={optionsList}
                                            name="category"
                                            placeholder='Category'
                                            value={optionsList.find(option => option.value === range.category) || null}
                                            onChange={(selectedOption) => handleRefChange(index, selectedOption)}
                                        />
                                    </div>
                                    <input className='col-3'
                                        name="min_value"
                                        placeholder='Min Value'
                                        value={range.min_value}
                                        onChange={(e) => handleRefRangeChange(index, e)}
                                    />
                                    <input className='col-3'
                                        name="max_value"
                                        placeholder='Max Value'
                                        value={range.max_value}
                                        onChange={(e) => handleRefRangeChange(index, e)}
                                    />
                                    <button
                                        className='remove-btn'
                                        onClick={() => removeRefRange(index)}
                                    >
                                        -
                                    </button>
                                </div>
                            ))}
                            <button className='add-btn' onClick={addRefRange}>
                                Add Reference Range
                            </button>
                        </div>
                        <div className='pricing-inputcontainer'>
                            <span>Panels</span>
                            <Select
                                styles={{
                                    control: (provided) => ({
                                        ...provided,
                                        minHeight: '44px',
                                        border: error.tests ? '1px solid red' : '1px solid #E3E3E3',
                                    }),
                                    menu: (provided) => ({
                                        ...provided,
                                        // maxHeight: '200px!important',
                                        zIndex: 9999,
                                    }),
                                    menuList: (provided) => ({
                                        ...provided,
                                        maxHeight: '200px!important',
                                        zIndex: 9999,
                                    }),
                                }}
                                isMulti
                                value={panels}
                                onChange={handleTestChange}
                                options={panelsList}
                                placeholder="Select Panels"
                            />
                            {error.panels && <p style={{ color: 'red' }}>{error.panels}</p>}
                        </div>
                        <div className='pricing-inputcontainer'>
                            <span>Note</span>
                            <input
                                name="note"
                                placeholder='Note'
                                value={testData.note}
                                onChange={handleInputChange}
                            />
                        </div>
                        <div style={{ display: "flex", gap: "10px", margin: "auto 0 0 auto" }}>
                            <button className='add-btn' onClick={props.onClose}>
                                Close
                            </button>
                            <button className='add-btn' onClick={handleSubmit}>
                                Save Changes
                            </button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    );
};

export default TestShow;